import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircleFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("mask", {
		id: "CheckCircleFill_cutout",
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M7 12L10.5 15.5L17 8.5",
			stroke: "black",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			fill: "none"
		})]
	}), /* @__PURE__ */ _jsx("path", {
		d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		fill: "currentColor",
		mask: "url(#CheckCircleFill_cutout)"
	})]
});
export default SvgCheckCircleFill;
